// JsFromRoutes CacheKey 84b559b38c5e528f61dc1730490dbac4
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  finalizeRedemption: /* #__PURE__ */ definePathHelper('post', '/testing_tools/recipient_gifts/:id/finalize_redemption'),
  autoredeemAndCredit: /* #__PURE__ */ definePathHelper('post', '/testing_tools/recipient_gifts/:id/autoredeem_and_credit'),
  setRedemptionDatesToPast: /* #__PURE__ */ definePathHelper('post', '/testing_tools/recipient_gifts/:id/set_redemption_dates_to_past'),
  setCardIssuingDatesToPast: /* #__PURE__ */ definePathHelper('post', '/testing_tools/recipient_gifts/:id/set_card_issuing_dates_to_past'),
  processPerfectGiftRedemption: /* #__PURE__ */ definePathHelper('post', '/testing_tools/recipient_gifts/:id/process_perfect_gift_redemption'),
  resetThankedAt: /* #__PURE__ */ definePathHelper('post', '/testing_tools/recipient_gifts/:id/reset_thanked_at'),
}
